export default "__VITE_ASSET__aa711193__"